/** Integer division with explicit rounding; never goes through floating point. */
export function divideRounded(numerator, denominator, mode = "half-even") {
    if (denominator === 0n)
        throw new RangeError("Division by zero");
    const negative = numerator < 0n !== denominator < 0n;
    const n = numerator < 0n ? -numerator : numerator;
    const d = denominator < 0n ? -denominator : denominator;
    const quotient = n / d;
    const remainder = n % d;
    let result = quotient;
    if (remainder !== 0n) {
        const twice = remainder * 2n;
        if (mode === "half-up" && twice >= d)
            result = quotient + 1n;
        if (mode === "half-even" && (twice > d || (twice === d && quotient % 2n === 1n)))
            result = quotient + 1n;
    }
    return negative ? -result : result;
}
//# sourceMappingURL=rounding.js.map